import memoize from 'lodash/memoize'

const isExecutedThroughJest = memoize((): boolean => {
  try {
    return !!process?.env?.JEST_WORKER_ID
  } catch {
    return false
  }
})

export default {
  // eslint-disable-next-line no-undef
  __DEV__: !!__DEV__,
  __TEST__: isExecutedThroughJest(),
}
